module.exports = __webpack_public_path__ + "img/hk.d55d2cf0.png";